export enum ResultNoteType {
    userMessage = 'user-message',
    internalEvent = 'internal-event',
}

export interface IResultNote {
    created_at: string;
    is_posted_by_app: boolean;
    note: string;
    type: ResultNoteType;
    uuid: string;
    user: null | {
        account_handle: string;
        display_name: string;
    };
}
